import { VoidFunctionComponent } from 'react';
import { CardProgressBar, StyledCardProgress } from './CardProgress.styled';
import { CardProgressProps } from './types';

export const CardProgress: VoidFunctionComponent<CardProgressProps> = props => {
  const { active = true } = props;

  return (
    <StyledCardProgress $active={active}>
      <CardProgressBar />
    </StyledCardProgress>
  );
};
